import React from "react";
import { graphql, Link } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import Button from "@material-ui/core/Button";
import Arrow from "@material-ui/icons/ChevronRight";
import AppLayout from "../components/Styles/AppLayout";
import LandingLayout from "../components/Styles/LandingLayout";
import PageList from "../components/PageList";
import HeroImage from "../Images/reference_hero.svg";

const useStyles = makeStyles(theme => ({
  hero: {
    minHeight: "500px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    alignItems: "center",
    "@media(max-width: 1024px)": {
      gridTemplateColumns: "1fr",
      marginBottom: "40px"
    },
    "@media(max-width: 667px)": {
      height: "auto"
    }
  },
  heading: {
    fontSize: "4rem!important",
    fontWeight: `${900}!important`,
    lineHeight: 1.25,
    "@media(max-width: 1024px)": {
      textAlign: "center"
    }
  },
  imageContainer: {
    textAlign: "right",
    "@media(max-width: 1024px)": {
      textAlign: "center"
    }
  },
  heroImage: {
    height: "350px",
    width: "auto",
    "@media(max-width: 667px)": {
      height: "auto",
      width: "100%"
    }
  },
  buttonContainer: {
    display: "flex",
    marginTop: "24px",
    "@media(max-width: 1024px)": {
      justifyContent: "center",
      marginBottom: "24px"
    }
  },
  button: {
    width: "200px",
    fontWeight: 600,
    letterSpacing: "0.1rem",
    padding: "8px 24px",
    borderRadius: "2rem",
    boxShadow: "none",
    backgroundColor: "#603556",
    "&:hover": {
      backgroundColor: "#482840",
      boxShadow: "none"
    }
  }
}));

const ReferencePage = ({ location, data, pageContext, navigate }) => {
  const classes = useStyles();
  const { totalCount, currentPage, numPages } = pageContext;

  return (
    <AppLayout location={location}>
      <LandingLayout>
        <div className="doc__inner-container">
          <div className={classes.hero}>
            <div>
              <h1 className={classes.heading}>
                Entry Event <br /> Referens
              </h1>
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                  component={Link}
                  to="/reference/biljettmall/"
                >
                  Starta
                  <Arrow />
                </Button>
              </div>
            </div>
            <div className={classes.imageContainer}>
              <HeroImage className={classes.heroImage} />
            </div>
          </div>
        </div>
        <div></div>
        <PageList
          numPages={numPages}
          totalCount={totalCount}
          currentPage={currentPage}
          pages={data.allContentfulReference.edges}
          navigate={navigate}
          section="reference"
        />
      </LandingLayout>
    </AppLayout>
  );
};

export const ReferenceQuery = graphql`
  query Reference($skip: Int!, $limit: Int!) {
    allContentfulReference(
      sort: { fields: index }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          title
          slug
          childContentfulReferenceContentTextNode {
            childMarkdownRemark {
              excerpt
            }
          }
        }
      }
    }
  }
`;

export default ReferencePage;
